import { Button } from "react-bootstrap";
import { IItem } from "../../api/types";

export const IncrementQuantityButton = (props: { value: number, item: IItem, update: (updates: Partial<IItem>) => void}) => {
  const onClick = () => {
    props.update({quantity: props.item.quantity + props.value});
  }
  return <Button 
    variant="outline-secondary"
    size="sm"
    onClick={onClick}>
    {props.value>0? '+' :''}{props.value}
  </Button>
}